export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-esthe-light-bronze via-esthe-mocha to-esthe-cafe-noir text-white py-16">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-esthe-rose to-esthe-light-coral rounded-2xl">
                <i className="ri-heart-pulse-line text-3xl text-white"></i>
              </div>
              <span className="text-3xl font-serif">ESTHÉ Clinic</span>
            </div>
            <p className="text-esthe-floral-white/80 leading-relaxed mb-6">
              Your trusted partner in aesthetic excellence. We combine artistry with advanced medical techniques to help you achieve your beauty goals safely and naturally.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-gradient-to-br hover:from-esthe-rose hover:to-esthe-light-coral transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-gradient-to-br hover:from-esthe-rose hover:to-esthe-light-coral transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-gradient-to-br hover:from-esthe-rose hover:to-esthe-light-coral transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 text-esthe-floral-white">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-esthe-floral-white/80 hover:text-esthe-rose transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" className="text-esthe-floral-white/80 hover:text-esthe-rose transition-colors cursor-pointer">
                  Services
                </a>
              </li>
              <li>
                <a href="#team" className="text-esthe-floral-white/80 hover:text-esthe-rose transition-colors cursor-pointer">
                  Our Team
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-esthe-floral-white/80 hover:text-esthe-rose transition-colors cursor-pointer">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#contact" className="text-esthe-floral-white/80 hover:text-esthe-rose transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 text-esthe-floral-white">Contact Info</h4>
            <ul className="space-y-3 text-esthe-floral-white/80">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>Eastlane by urbnlanes<br />New Cairo 1, Cairo Governorate 4740003</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>+1 (555) 123-4567</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>info@esthe-clinics.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-esthe-floral-white/60 text-sm">
            © 2024 ESTHÉ Clinic. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-esthe-floral-white/60 hover:text-esthe-rose transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-esthe-floral-white/60 hover:text-esthe-rose transition-colors cursor-pointer">
              Terms of Service
            </a>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-esthe-floral-white/60 hover:text-esthe-rose transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
